import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';
import { LoginService } from '../../../shared-modules/login/login.service';
import { StudentTeamAttendanceDetails } from '../../../shared-components/student/attendance.model';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';

@Component({
  selector: 'app-by-team-details',
  templateUrl: './by-team-details.component.html'
})
export class ByTeamDetailsComponent implements OnInit {

    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    columnsToDisplay = ['Day', 'date', 'attCode', 'attDescription', 'type', 'ampm'];
    @Input() attendanceDetails: StudentTeamAttendanceDetails[];
    V10: boolean;
    constructor(private loginService: LoginService,) {
        this.V10 = this.loginService.LoginSettings.V10;
    }

  ngOnInit() {
    this.angularMatData.data = this.attendanceDetails;
    this.angularMatData.sort = this.sort;
  }

  getAriaDetailRowByTeamAttendanceDetails(row: StudentTeamAttendanceDetails): string {
    let colList: string[] = [];
    let dataList: string[] = [];
    if (this.V10) {
        colList = ['date',
            'attCode',
            'attDescription',
            'type',
            'ampm'];

        dataList = [new Date(row.date).toDateString(),
        row.attCode,
        row.attDescription,
        row.type,
        row.ampm];
        }
        return AriaDirective.concatAriaStrings(colList, dataList);
      }
}